import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  variablesBannerText,
  variablesBonusDisplayDate,
} from '/redux/selector/remoteConfig.selector';

import {BonusProgressBar} from './BonusProgressBar';

export default connect(
  createStructuredSelector({
    bonusData: variablesBannerText,
    doubleDoubleBonusPeriod: variablesBonusDisplayDate,
  }),
  _dispatch => ({}),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
    };
  },
)(BonusProgressBar);
